function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#E2DBD5;}\r\n\t.st1{fill:#D4CCC7;}\r\n\t.st2{fill:#EFEBE8;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Filled"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M334.8,264H177.4c0,0-17.4,56,23.3,104H312C352,320,334.8,264,334.8,264z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M193.7,358.9c2.1,3.1,4.4,6.1,7,9.1H312c40-48,22.8-104,22.8-104h-9.1C294.1,310,247.4,343.6,193.7,358.9z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 196,
  cy: 292,
  r: 12
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Outline"
}, /*#__PURE__*/React.createElement("path", {
  d: "M384,256H128c-4.4,0-8,3.6-8,8s3.6,8,8,8h39.4c-3.3,19.4-5.6,62.5,27.2,101.2c3.6,4.2,8.4,2.4,13.5,2.8v12 c-26.4,21-32,21.1-32,28v3.7c-19,13.4-22.5,13.2-23.8,18.3l-8,32c-1.1,4.3,1.5,8.6,5.8,9.7s8.6-1.5,9.7-5.8c0,0,0-0.1,0-0.1l7.2-29 l9-6V488c0,4.4,3.6,8,8,8s8-3.6,8-8v-20.7l10.3,10.3c3.1,3.1,8.2,3.1,11.3,0s3.1-8.2,0-11.3L192,444.7V420l28.8-21.6 c5.2-3.9,2.5-9.4,3.2-22.4h32v12l-28.8,21.6c-3.5,2.7-4.2,7.7-1.6,11.2c1.5,2,3.9,3.2,6.4,3.2c4.6,0,5.7-2.9,24-16v12.7 c-29.1,29.8-32.3,29.5-32.3,35.3v48c0,4.4,3.6,8,8,8s8-3.6,8-8v-44.7l6.1-6l10.3,20.6V488c0,4.4,3.6,8,8,8s8-3.6,8-8 c-1-25.2,4.6-7.9-14.3-46.5c9.9-10.6,14.3-12,14.3-17.5v-48h16c0.7,30.9-1.7,33.6,2.3,37.7l11.4,11.4c-11.8,18.4-13.7,18.8-13.7,23 v16c0,4.4,3.6,8,8,8s8-3.6,8-8v-13.6l9.2-13.9l6.8,6.8V488c0,4.4,3.6,8,8,8s8-3.6,8-8v-8l19.2,14.4c3.5,2.7,8.5,1.9,11.2-1.6 c2.7-3.5,1.9-8.5-1.6-11.2c0,0,0,0,0,0L336,460c-0.6-18.2,1.6-21.7-2.3-25.7L304,404.7v-2.4c23.3,5.7,22.3,5.8,24,5.8 c9.4,0,11-13.5,1.9-15.8l-25.9-6.5V376c5.6-0.5,10.5,1.5,14.1-2.9c32.2-38.7,29.9-81.8,26.6-101.1H384c4.4,0,8-3.6,8-8 S388.4,256,384,256L384,256z M308.2,360H204.4c-20.7-26.2-26.4-58.8-20.7-88h144.8C331.2,286.3,335.3,325.1,308.2,360z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240,288c-4.4,0-8,3.6-8,8v40c0,4.4,3.6,8,8,8s8-3.6,8-8v-40C248,291.6,244.4,288,240,288z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M272,288c-4.4,0-8,3.6-8,8v40c0,4.4,3.6,8,8,8s8-3.6,8-8v-40C280,291.6,276.4,288,272,288z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304,288c-4.4,0-8,3.6-8,8v32c0,4.4,3.6,8,8,8s8-3.6,8-8v-32C312,291.6,308.4,288,304,288z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208,288c-4.4,0-8,3.6-8,8v32c0,4.4,3.6,8,8,8s8-3.6,8-8v-32C216,291.6,212.4,288,208,288z"
}));

var SvgSiteFarrow = function SvgSiteFarrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSiteFarrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/site-farrow.09d2ac7d.svg";
export { ForwardRef as ReactComponent };